<template>
<div class="companyList companyListConCept" v-if="tableData.length>0">
        <div class="box">
            <ul style="margin:10px auto;">
                <li v-if="tableData.length>0">
                    <el-table :data="tableData" border @cell-click="clickCompanyName">
                        <el-table-column  label="证券简称" prop="securityName">
                        </el-table-column>
                        <el-table-column  label="证券代码" prop="securityCode"></el-table-column>
                    </el-table>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'companyList',
    data() {
        return {
            tableData: [],     //生产公司,
            isCenpetCode:""
        }
    },
    computed:{...mapState(['productRouterInfo','conceptList'])},
    created(){
       this.isCenpetCode = this.conceptList.code;
    },
    methods: {
        //获取概念相关公司
        getRelatedCompanyFromConcept(params){
            this.$store.dispatch('getRelatedCompanyFromConcept',{conceptCode:params.code}).then( res => {
                if( res.data.retCode == '000'){
                    this.tableData = res.data.data
                }
            })
        },
         //点击公司，跳转相应公司
        clickCompanyName(row, event, column){
            let params = {}
            params.name = row.securityName;
            params.securityCode = row.securityCode;
            params.coCode = row.coCode
            params.type = 'company'
            this.$store.dispatch('productRouterInfo',params);
        }

    },
    mounted(){
        this.getRelatedCompanyFromConcept(this.conceptList);
    },
    watch:{
        conceptList:{
             handler(newVla, oldVal) {
                if( this.isCenpetCode != this.conceptList.code){
                    this.getRelatedCompanyFromConcept(this.conceptList);
                }
            },
            deep: true
        }
    }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/companyList.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/companyCom/coreConceptList.vue